export default __webpack_public_path__ + "images/11dc325d04db38e1d7f23b6cc9ae170f-independence_day_small.webp";